import isEmptyOrZero from './validation/isEmptyOrZero';
import versionCheck from './validation/versionCheck';

export default {
  isEmptyOrZero,
  versionCheck,
};
